import dayjs from 'dayjs';
import _ from 'lodash';

import type { Event, GroupedByDayEvents } from '../../Data/types';
import { compareAsc } from '../datePickerRangeUtils/datePickerRangeUtils';

export function groupEventsByDay(events: Event[] | undefined, dates: string[]): GroupedByDayEvents {
  if (!events) return {};
  const groupedByDay = _.groupBy(events, (event) => {
    // Parse the date using the JavaScript Date constructor for ISO 8601 strings
    const startDate = event.eventDateTime?.start ?? dayjs(); // Check if the date is valid, if not, exclude it from grouping
    if (!startDate.isValid()) {
      console.error(`Invalid date for event: ${event.title}`, event.eventDateTime?.start);
      return 'invalid-date'; // or handle invalid dates as needed
    }
    // Group by the date part only
    return startDate.format('YYYY-MM-DD');
  });

  // Remove 'invalid-date' group if needed
  delete groupedByDay['invalid-date'];
  Object.keys(groupedByDay).forEach((day) => {
    groupedByDay[day].forEach((event) => {
      const differencesInDays = dayjs(event.eventDateTime!.end).diff(event.eventDateTime!.start, 'day');
      if (differencesInDays > 0) {
        const startDate = event.eventDateTime!.start!;
        for (let i = 1; i <= differencesInDays; i++) {
          const newDate = startDate.add(i, 'day');
          if (!dates.includes(newDate.format('YYYY-MM-DD'))) continue;
          // push event to the new date if the event does not exist already
          if (!groupedByDay[newDate.format('YYYY-MM-DD')]?.find((e) => e.uuid === event.uuid)) {
            if (groupedByDay[newDate.format('YYYY-MM-DD')]) {
              groupedByDay[newDate.format('YYYY-MM-DD')].push(event);
            } else {
              groupedByDay[newDate.format('YYYY-MM-DD')] = [event];
            }
          }
        }
      }
    });
  });
  if (dates.length > 0) {
    Object.keys(groupedByDay).forEach((day) => {
      // delete if the date is not in the filter
      if (!dates.includes(day)) {
        delete groupedByDay[day];
      }
    });
  }
  // Sort the events in each day by start time
  Object.keys(groupedByDay).forEach((day) => {
    groupedByDay[day].sort((a, b) => {
      // Ensure start times are not null before converting to Date
      const startA = a.eventDateTime?.start ?? dayjs();
      const startB = b.eventDateTime?.start ?? dayjs();
      return compareAsc(startA, startB);
    });
  });
  return groupedByDay;
}
